export default __webpack_public_path__ + "static/media/Pp.c3406583.mp3";